var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',_vm._b({class:_vm.resolvedTypeClass,attrs:{"type":"text","size":"small","disabled":_vm.disabled,"icon":_vm.resolvedIcon},on:{"click":function($event){return _vm.$emit('click', $event)}}},'el-button',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }